import translate from '@translate';
import React, { FC } from 'react';
import Grid, { GridItem } from 'src/components/Grid';
import TextField from 'src/components/TextField';
import { ProductSetType } from 'src/types/productSet';
import { patternSku } from 'src/utils/constatns';
import { FormErrorsType, OnChangeType } from '../../types/global';
import { EditKeysType } from './constants';

export interface DetailPropsType {
    onChange: OnChangeType<EditKeysType>;
    editData: ProductSetType;
    editErrors: FormErrorsType;
    newProductSet: boolean;
    disableEdit: boolean;
}

const Detail: FC<DetailPropsType> = (props) => {
    return (
        <Grid>
            <GridItem cols={5}>
                <TextField
                    value={props.editData.SET_SKU}
                    error={props.editErrors.SET_SKU}
                    onChange={(value, error) => props.onChange('SET_SKU', value, error)}
                    name="SET_SKU"
                    label={translate('productSetDetail.setSku')}
                    fullWidth
                    required
                    disabled={props.disableEdit}
                    inputProps={{ pattern: patternSku }}
                />
            </GridItem>
        </Grid>
    );
};

export default Detail;
